import '@fontsource-variable/roboto-condensed';
function setLoadingScreenCookie(value) {
  const hours = 12
  const date = new Date()
  date.setTime(date.getTime() + hours * 60 * 60 * 1000)

  document.cookie = `loading_screen=${value}; expires=${date.toUTCString()}; path=/; SameSite=Lax`
}

setLoadingScreenCookie(true)
